import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { EventProvider } from "@/context/EventContext";
import Booth from "@/pages/Booth";
import SharePage from "@/pages/SharePage";
import AdminPage from "@/pages/AdminPage";
import Slideshow from "@/pages/Slideshow";

function App() {
  return (
    <div className="App">
      <EventProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Booth />} />
            <Route path="/share/:id" element={<SharePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/slideshow" element={<Slideshow />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#170F26", color: "#fff", border: "1px solid rgba(255,255,255,0.1)" } }} />
      </EventProvider>
    </div>
  );
}

export default App;
